import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useWithdrawRequestMutation = () => {
  return ApprovalFlows.withdrawRequest();
};

export default useWithdrawRequestMutation;
